import {
  EndpointConfig,
  RequestConfig,
  UseApiRequest
} from "src/core/shared/api/config.api";
import useAxios from "src/core/shared/hooks/useAxios";

export interface StringResponse {
  message: string;
}

type NutritionEndpointConfig = {
  EXPORT_PRODUCT_NUTRITION: EndpointConfig<
    null,
    StringResponse
  >;
};

// supportTicket api specific logic

const BASE_URL = `${process.env.REACT_APP_API_URL}/nutrition`;

const requests: RequestConfig<NutritionEndpointConfig> = {
  EXPORT_PRODUCT_NUTRITION: () => ({
    url: `${BASE_URL}/export/all`,
    method: "GET"
  })
};

export const useNutritionApi: UseApiRequest<NutritionEndpointConfig> = name => useAxios(requests[ name ], name);
